import React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import {ErrorBounds} from './components/error';

import registerServiceWorker from './registerServiceWorker';
import {Provider} from "react-redux";

import { createBrowserHistory } from 'history';
import configureStore from './configureStore';
import { addLocaleData } from 'react-intl';

//Languages Supported So Far..
import en from 'react-intl/locale-data/en';
import nl from 'react-intl/locale-data/nl';
import ru from 'react-intl/locale-data/ru';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import gr from 'react-intl/locale-data/el';
import rs from 'react-intl/locale-data/sr';
import ro from 'react-intl/locale-data/ro';
import tr from 'react-intl/locale-data/tr';
import cs from 'react-intl/locale-data/cs';
import it from 'react-intl/locale-data/it';
import es from 'react-intl/locale-data/es';


import {StaticRouter} from "react-router";
// eslint-disable-next-line import/default

import Home from "./pages/home";
import Support from "./pages/support";
import About from "./pages/about";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";
import Profile from "./pages/profile";
import Page404 from "./pages/page404";
import Signup from "./pages/signup";
import Confirm from "./pages/confirm";
import Dictionary from "./pages/dictionary";
import Login from "./pages/login";
import ResetPassword from "./pages/resetpassword";
import Links from "./pages/links";
import SeoPage from "./pages/seopage";
import Agency from "./pages/agency";
import AgencyList from "./pages/agencylist";
import SearchList from "./pages/searchlist";
import SiteMap from "./pages/sitemap";

import * as bActs from './actions/blog-actions';

import {Route, BrowserRouter, Switch, withRouter} from "react-router-dom";
import BlogList from "./pages/bloglist";
import BlogPost from "./pages/blogpost";
import * as wActs from "./actions/website-actions";

addLocaleData([...en, ...nl, ...ru, ...fr, ...de, ...gr, ...rs, ...ro, ...tr, ...cs, ...it, ...es]);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

const initialState = (window).initialReduxState;


const htmlSections = JSON.parse(atob(window.htmlSectionsEncoded));
initialState.Website.Settings.HtmlSections = htmlSections;

function genRoutes(routes,store) {

  let rtes = routes;

  const state = store.getState();
  const locPth = state.Website.Settings.LocationPath;
  const doDyn = wActs.isNullOrUndefined(state.Website.Settings.TagsInLinksEnabled) ? false : state.Website.Settings.TagsInLinksEnabled;

  let tags = rtes.map((v,i) => {

    let ren = (props)=><Home pageType={"home"} dynamiclink={false} {...props} />;
    switch(v.template.toLowerCase()) {
      case "home","profileslist": {
        if(v.path.indexOf("/search")>-1) {
          ren = (props) => <SearchList pageType={"searchlist"} {...props} />;
        }
        break;
      }
      case "sitemap": {
        ren = (props) => <SiteMap pageType={"sitemap"} {...props} />;
        break;
      }

      case "agentslist": {
        ren = (props) => <AgencyList pageType={"agentslist"} {...props} />;
        break;
      }
      case "searchlist": {
        ren = (props) => <SearchList pageType={"searchlist"} {...props} />;
        break;
      }
      case "support": {
        ren = (props)=><Support pageType={"support"} {...props} />;
        break;
      }
      case "links": {
        ren = (props)=><Links pageType={"links"} {...props} />;
        break;
      }
      case "signup": {
        ren = (props) => <Signup pageType={"signup"} {...props} />;
        break;
      }
      case "confirm": {
        ren = (props) => <Confirm pageType={"confirm"} {...props} />;
        break;
      }
      case "about": {
        ren = (props)=><About pageType={"home"} {...props} />;
        break;
      }
      case "terms": {
        ren = (props)=><Terms pageType={"home"} {...props} />;
        break;
      }
      case "privacy": {
        ren = (props)=><Privacy pageType={"home"} {...props} />;
        break;
      }
      case "escortdictionary": {
        ren = (props) => <Dictionary pageType={"dictionary"} {...props} />;
        break;
      }
      case "login": {
        ren = (props) => <Login pageType={"login"} {...props} />;
        break;
      }
      case "resetpassword": {
        ren = (props) => <ResetPassword pageType={"resetpassword"} {...props} />;
        break;
      }
      case "profile": {
        ren = (props)=><Profile pageType={"profile"} {...props} />;
        break;
      }
      case "404": {
        ren = (props) => <Page404 pageType={"404"} {...props} />;
        break;
      }
      case "blog": {
        store.dispatch(bActs.SetBlogPathValue(wActs.stripCulturePath(v.path)));
        ren = (props) => <BlogList pageType={"bloglist"} {...props} />;
        break;
      }
      case "agent": {
        ren = (props) => <Agency pageType={"agency"} {...props} />;
        break;
      }
      default: {
        ren = (props) => <SeoPage pageType={"seopage"} {...props} />;
        break;
      }
    }
    if(v.path === "") {
      v.path = "/";
    }

    if(v.template.toLowerCase() === "profile") {
      let pth = v.path + "([+-]?[0-9]\\d*|0)";
      return (
        <Route
          key={"rtr-main-" + i}
          path={pth}
          render={ren}/>
      );
    } else if(v.template.toLowerCase() === "agent") {
      let pth = v.path + "([+-]?[0-9]\\d*|0)";
      //console.log(pth.substr(1));
      let rArr = [];
      rArr.push(<Route key={"rtr-main-1" + i} path={"/escort-agency-" + pth} render={ren}/>);
      rArr.push(<Route key={"rtr-main-2" + i} path={"/private-apartment-" + pth} render={ren}/>);
      rArr.push(<Route key={"rtr-main-3" + i} path={"/sex-club-" + pth} render={ren}/>);
      rArr.push(<Route key={"rtr-main-4" + i} path={"/erotic-massage-" + pth} render={ren}/>);
      rArr.push(<Route key={"rtr-main-5" + i} path={"/massage-parlor-" + pth} render={ren}/>);
      rArr.push(<Route key={"rtr-main-6" + i} path={"/sauna-" + pth} render={ren}/>);
      rArr.push(<Route key={"rtr-main-7" + i} path={"/directory-" + pth} render={ren}/>);
      return (rArr);
    } else if(v.template.toLowerCase() === "blog") {

      let bRoutes = [];
      bRoutes.push(
        <Route
          key={"rtr-blogposts-" + i}
          path={v.path}
          exact
          render={ren} />
      );
      bRoutes.push(
        <Route
          key={"rtr-blogpost-" + i}
          path={v.path + "/:slug"}
          exact
          render={(props) => <BlogPost pageType={"blogpost"} {...props} />} />
      );
      return bRoutes;
    } else {
      return (
        <Route
          key={"rtr-main-" + i}
          path={v.path}
          exact
          render={ren} />
      );
    }


  });


  //Adding Here To New Paths For /country/city/tag

  //if(doDyn) {
    if(!wActs.isNullOrEmpty(locPth)) {
      tags.push(
        <Route
          key={"rtr-tag1"}
          path={`/${locPth}/:tag1`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag2"}
          path={`/${locPth}/:tag1/:tag2`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag3"}
          path={`/${locPth}/:tag1/:tag2/:tag3`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );

      tags.push(
        <Route
          key={"rtr-tag1-lang"}
          path={`/:lang/${locPth}/:tag1`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag2-lang"}
          path={`/:lang/${locPth}/:tag1/:tag2`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag3-lang"}
          path={`/:lang/${locPth}/:tag1/:tag2/:tag3`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
    } else {
      tags.push(
        <Route
          key={"rtr-tag1"}
          path={`/:tag1`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag2"}
          path={`/:tag1/:tag2`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag3"}
          path={`/:tag1/:tag2/:tag3`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );

      tags.push(
        <Route
          key={"rtr-tag1-lang"}
          path={`/:lang/:tag1`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag2-lang"}
          path={`/:lang/:tag1/:tag2`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
      tags.push(
        <Route
          key={"rtr-tag3-lang"}
          path={`/:lang/:tag1/:tag2/:tag3`}
          render={(props) => <Home pageType={"homedyn"} {...props} dynamiclink={true} />} />
      );
    }
  //}




  return tags;
}


function renderApp() {
  let his = null;
  const renderMethod = !module.hot ? ReactDOM.render : ReactDOM.hydrate;

  //console.log(initialState.Website.Page.Name)

  //if(initialState.Website.Page.Name === "404") {
  //  withRouter(({history}) => {
  //    history.push('en/4042234234');
  //    his = history;
  //  });
  //}
  let store = configureStore(his,initialState);

  ReactDOM.hydrate((
    <ErrorBounds>
    <Provider store={store}>
      <BrowserRouter >
        <App>
          <Switch>
            {genRoutes(initialState.Website.Routes, store)}
            <Route
              key={"rtr-404"}
              render={(props) => <Page404 pageType={"404"} {...props} />} />
          </Switch>
        </App>
      </BrowserRouter>
    </Provider>
    </ErrorBounds>
  ), document.getElementById('main-scrollbar'));
}

renderApp();

if(module.hot) {
  module.hot.accept('./App.js', () => {
    //routes = require('./routes').routes;
    renderApp();
  });
}
registerServiceWorker();
